import { render, staticRenderFns } from "./StatisticsMember.vue?vue&type=template&id=263ae4e6&scoped=true&"
import script from "./StatisticsMember.vue?vue&type=script&lang=js&"
export * from "./StatisticsMember.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsMember.vue?vue&type=style&index=0&id=263ae4e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263ae4e6",
  null
  
)

export default component.exports